import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type StarFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const StarFilled = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: StarFilledProps) =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      fill: color,
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(-5.362631 -4.924235) scale(1.309772)',
        },
        [
          h(
            'path',
            {
              "fill-rule": 'evenodd',
              "clip-rule": 'evenodd',
              d: 'M19.2794 4.69289C19.3198 4.47477 19.6323 4.47477 19.6727 4.69289L20.0485 6.72226C20.0618 6.79411 20.1132 6.85298 20.1826 6.87582L21.8989 7.44076C22.0822 7.50109 22.0822 7.76038 21.8989 7.82071L20.1826 8.38565C20.1132 8.40849 20.0618 8.46736 20.0485 8.53921L19.6727 10.5686C19.6323 10.7867 19.3198 10.7867 19.2794 10.5686L18.9037 8.53921C18.8904 8.46736 18.839 8.40849 18.7696 8.38565L17.0532 7.82071C16.8699 7.76038 16.8699 7.50109 17.0532 7.44076L18.7696 6.87582C18.839 6.85298 18.8904 6.79411 18.9037 6.72226L19.2794 4.69289ZM10.6338 5.07121C10.7957 4.48374 11.6288 4.48374 11.7907 5.07121L13.1557 10.0246C13.2014 10.1903 13.3159 10.3284 13.4702 10.404L17.6124 12.4333C18.0605 12.6528 18.0605 13.2915 17.6124 13.511L13.4702 15.5403C13.3159 15.6159 13.2014 15.754 13.1557 15.9197L11.7907 20.8731C11.6288 21.4606 10.7957 21.4606 10.6338 20.8731L9.26881 15.9197C9.22316 15.754 9.10866 15.6159 8.95434 15.5403L4.81211 13.511C4.36406 13.2915 4.36406 12.6528 4.81211 12.4333L8.95434 10.404C9.10866 10.3284 9.22316 10.1903 9.26881 10.0246L10.6338 5.07121ZM16.9036 16.6002C16.846 16.4113 16.5785 16.4113 16.521 16.6002L16.1864 17.6983C16.1701 17.7521 16.1318 17.7965 16.0811 17.8206L15.0917 18.2916C14.9396 18.3639 14.9396 18.5804 15.0917 18.6527L16.0811 19.1237C16.1318 19.1478 16.1701 19.1922 16.1864 19.246L16.521 20.3441C16.5785 20.5331 16.846 20.5331 16.9036 20.3441L17.2381 19.246C17.2545 19.1922 17.2927 19.1478 17.3435 19.1237L18.3329 18.6527C18.4849 18.5804 18.4849 18.3639 18.3329 18.2916L17.3435 17.8206C17.2927 17.7965 17.2545 17.7521 17.2381 17.6983L16.9036 16.6002Z',
            },
          ),
        ],
      ),
    ],
  );

export default StarFilled;
